<template>
  <main>
    <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="container">
      <div class="main-wrapper">
          <form class="order-list" @submit.prevent="sendForm()">
            <h1 class="main-title">ваш заказ</h1>
            <div class="order-items" v-if="!isCartEmpty">
                <CartItem 
                    @delCartItem="removeCartItem($event)"
                    v-for="(product, index) in localCart" 
                    :key="index"
                    :product="product">
                </CartItem>
            </div>
            <div class="order-items" v-else style="margin-bottom: 30px;">
                Товаров в корзине нет!
            </div>
            <a :href="collectionUrl" class="backToCatalog">Вернуться в коллекцию</a>
            <input id="send-form" :class="{blockedButton: blockButton}" type="submit" :value="buttonText">
        </form>
      </div>
    </div>
  </main>
</template>
<script>
import CartItem from "@/components/cart/cartItem";
export default {
  components: { CartItem },
  data: () => ({
      localCart: {},
      collectionUrl: '',
      buttonText: "Заказать",
      blockButton: false,
      preloader: false
  }),
  methods: {
      removeCartItem(e){
        this.$delete(this.localCart, e)
        this.$localStorageSet('miniCart', this.localCart)
      },
      sendForm(){
        this.blockButton = true;
        this.preloader = true;
        if(!this.isCartEmpty){
          this.$store.dispatch('CREATE_ORDER').then(r =>{
            this.$makeToast(
              "Поздравляем!",
              "success",
              `Заказ успешно сформирован! 
              ID заказа = ${r.data.data.orderId}`
            );
            // this.$localStorageSet('orderID', r.data.data.orderId);
            setTimeout(()=>{this.$router.push({name: 'targetsPage' })}, 3000)
            // setTimeout(()=>{this.$router.push({name: 'comment' })}, 3000)
          })
        }else{
          this.$store.dispatch('CREATE_ORDER_EMPTY').then(r=>{
            this.$router.push({name: 'comment' })
          })
        } 
      }
  },
  created(){
      this.localCart = this.$localStorageGet('miniCart');
      this.collectionUrl ='catalog/'+ this.$localStorageGet('currentCollection').info.id; //Url текущей коллекции
  },
  computed: {
      isCartEmpty(){  //Проверить пустая корзина или нет
          if(Object.keys(this.localCart).length == 0){
            this.buttonText ="Закончить презентацию"
          }else{
            this.buttonText ="Заказать"
          }

          return Object.keys(this.localCart).length == 0 ? true : false
      }
  },
  watch: {
      localCart: {
        handler(val){
            this.$localStorageSet('miniCart', val)
        },
        deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
  #send-form{
    font-size: 16px;
  }
</style>